import { anyOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

const isBaseIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  api_key: anyOf(string, () => true),
  connected_at: anyOf(string, () => true),
});

const isGeminiIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  api_key: anyOf(string, () => true),
  connected_at: anyOf(string, () => true),
  use_vertex_ai: boolean,
  vertex_project_id: anyOf(string, () => true),
  use_oauth: maybe(boolean),
  google_account_email: anyOf(string, () => true),
  oauth_connected_at: anyOf(string, () => true),
  oauth_project_id: anyOf(string, () => true),
  oauth_project_name: anyOf(string, () => true),
  oauth_connected: maybe(boolean),
  oauth_pending: maybe(boolean),
});

const isDatabricksMosaicIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  api_key: string,
  connected_at: string,
  workspace_name: string,
});

export const isGetAlloysProviderAgenticAppGroupIdResult = objectOf({
  integration: anyOf(isGeminiIntegration, isDatabricksMosaicIntegration, isBaseIntegration, objectOf({})),
});
